import React, { memo } from "react";
import "./styles.css";

const HouseCircularButton = ({ text, handleOnClick, ...rest }) => {
    return (
        <div
            className="house-circular-button"
            role="presentation"
            onClick={handleOnClick}
            {...rest}
        >
            {text}
        </div>
    );
};

export default memo(HouseCircularButton);
